/* eslint-disable class-methods-use-this */

class DefaultErrorNormalizationStrategy {
  normalizeResponse(response) {
    return Promise.resolve(response);
  }
}

export { DefaultErrorNormalizationStrategy as default };
//# sourceMappingURL=DefaultErrorNormalizationStrategy.js.map
